// Financials tab redesign — read-only client for the loan's "Phoenix Income
// Pools" booked ledger: a per-period projection over recognized IncomeEvents
// (owner ruling D-18 — no materialized booked table), pivoted across the
// revenue pools (Baseline income lands under the non-commissionable pool G),
// plus the per-period event drill-down.

import { api } from "@/api/client";

export interface IncomePoolColumnDto {
  code: string;
  name: string;
  isCommissionable: boolean;
  isRetired: boolean;
}

export interface IncomePoolCellDto {
  /** Null = the defensive "unattributed" bucket (fail-soft recognition left
   *  a PhoenixFee event pool-less) — surfaced, never silently dropped. */
  poolCode: string | null;
  amount: number;
  eventCount: number;
}

export interface IncomePoolsPeriodRowDto {
  /** Month-bucket key: first of the month, UTC. */
  periodStart: string;
  pools: IncomePoolCellDto[];
  total: number;
  eventCount: number;
}

export interface LoanIncomePoolsDto {
  loanId: string;
  loanNumber: string;
  pools: IncomePoolColumnDto[];
  periods: IncomePoolsPeriodRowDto[];
}

export interface IncomePoolEventDto {
  id: string;
  recognizedAt: string;
  periodStart: string | null;
  sourceType: string;
  paymentId: string | null;
  obligationTypeSnapshot: string | null;
  classification: string;
  poolCode: string | null;
  expectedAmount: number;
  receivedAmount: number;
}

export const incomePoolsApi = {
  get: (loanId: string) =>
    api.get<LoanIncomePoolsDto>(`/portfolio-admin/loans/${loanId}/income-pools`),
  events: (loanId: string, periodStart: string) =>
    api.get<IncomePoolEventDto[]>(
      `/portfolio-admin/loans/${loanId}/income-pools/events?periodStart=${encodeURIComponent(periodStart)}`,
    ),
};
